module.exports = __webpack_public_path__ + "img/6.4d7ed663.png";